import React from 'react';
import Partners from '../partners/Partners';
export default function PartnersPage(){ return <Partners />; }
